<template>
  <div class="map-stats-bar" v-if="stats && stats.length">
    <div
      v-for="stat in stats"
      :key="stat.title"
      class="stat-card"
    >
      <div class="stat-icon-wrap" :style="{ background: hexToRgba(stat.color, 0.12) }">
        <v-icon :color="stat.color" size="20">{{ stat.icon }}</v-icon>
      </div>
      <div class="stat-content">
        <div class="stat-value" :style="{ color: stat.color }">{{ formatValue(stat.value) }}</div>
        <div class="stat-label">{{ stat.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapStatistics',
  props: {
    stats: {
      type:    Array,
      default: () => [],
    },
  },
  methods: {
    formatValue(v) {
      if (v === null || v === undefined) return '—';
      if (typeof v === 'number' && v >= 1000) return (v / 1000).toFixed(1) + 'k';
      return String(v);
    },
    hexToRgba(hex, alpha) {
      if (!hex) return `rgba(100,100,100,${alpha})`;
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r},${g},${b},${alpha})`;
    },
  },
};
</script>

<style scoped>
.map-stats-bar {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
  justify-content: center;
  padding: 0 12px;
  pointer-events: none;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);
  pointer-events: auto;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
}

.stat-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-value {
  font-family: poppinsmedium, 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
}

.stat-label {
  font-family: poppinsregular, 'Poppins', sans-serif;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.2;
  margin-top: 1px;
}

@media (max-width: 600px) {
  .map-stats-bar {
    top: auto;
    bottom: 70px;
    left: 0;
    right: 0;
    width: 100vw;
    transform: none;
    overflow-x: auto;
    justify-content: flex-start;
    padding: 0 16px;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none;
    pointer-events: auto; /* allow scrolling */
  }
  .map-stats-bar::-webkit-scrollbar {
    display: none;
  }
  .stat-card {
    flex-shrink: 0;
  }
}
</style>
